// extracted by mini-css-extract-plugin
module.exports = {"loader-wrapper":"_2fh9_","loaderWrapper":"_2fh9_","font-upgrade":"_1zuMw","fontUpgrade":"_1zuMw"};